module.exports = __webpack_public_path__ + "static/media/walking.ef4de2a8.svg";